import _ from 'lodash'
import { ActionType, createAction } from 'typesafe-actions'

import { FlashContent } from './types'

export const showFlashNotice = createAction('/components/FlashNotice/SHOW', (resolve) => {
  return (flashContent: _.Omit<FlashContent, 'show'>) =>
    resolve({
      show: true,
      ...flashContent,
    })
})

export const hideFlashNoticeBegin = createAction('/components/FlashNotice/HIDE_BEGIN')

export const hideFlashNoticeEnd = createAction('/components/FlashNotice/HIDE_END')

export type FlashNoticeAction = ActionType<
  typeof showFlashNotice | typeof hideFlashNoticeBegin | typeof hideFlashNoticeEnd
>
